import React, { useContext, useEffect, useState } from 'react'
import UserContext from '../../frontendTestContext/UserContext'
import { HiSparkles } from 'react-icons/hi'
import axios from 'axios'
// import { FaPlus, FaTimes } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import OopsX from '../oops/OopsX'

const EditProduct = (props) => {
    const userContextUsed = useContext(UserContext)
    const user = userContextUsed.user

    const [productInfo, setProductInfo] = useState({
        productName: "",
        productSlug: "",
        productPrice: "",
        description: "",
        category: "Softwares",
        productThumbnailFile: "",
        productGalleryFile: "",
        productOwner: "",
        productId: "",
        createdAt: "",
    })

    const shopData = userContextUsed.shop.products

    const [notFound, setNotFound] = useState(false)
    
    const productSlug = useParams()
    const productSlugId = productSlug.productId
    // detailsFromBackend.productId
    useEffect(()=>{
        const productsFiltered = shopData.filter((product)=>{
            return product.productDetailsFromBackend.productUrls.productUrl === productSlugId
        })
        
        if(productInfo.productName.length < 1){
            if(productsFiltered.length > 0){
                const thisProduct = productsFiltered[0]
                const detailsFromBackend = thisProduct.productDetailsFromBackend
                setNotFound(false)
                if(detailsFromBackend.productOwner.userId === user.userId){
                    setNotFound(false)
                    setProductInfo((prev)=>{
                        return({
                            ...prev,
                            productName: detailsFromBackend.productName,
                            productSlug: detailsFromBackend.productUrls.productUrl,
                            productPrice: detailsFromBackend.productPriceInDollar,
                            description: detailsFromBackend.productHeadline,
                            category: detailsFromBackend.productCategory,
                            productId: detailsFromBackend.productId,
                            createdAt: detailsFromBackend.createdAt, 
                            productOwner: detailsFromBackend.productOwner.userId 
                        })
                    })
                } else{
                    setNotFound(true)
                }
            } else{
                setNotFound(true)
            }
        }
    }, [shopData, productSlugId, productInfo, user])
    
    function toggleCategory(value){
        setProductInfo((prev)=>{
            return({
                ...prev,
                category: value
            })
        })
    }

    const navigate = useNavigate()
    
    async function handleSubmit(e){
        e.preventDefault()
        console.error()
        console.log("Try Edit")

        // formData.append("id", productInfo.productId);
        

        if(userContextUsed.isLoggedIn){
            if(user.isSeller){
                props.handleLoader(true)
                console.clear()
                const access = localStorage.getItem("access")
                console.log(productInfo.productId)
                const formData = new FormData();
                formData.append("title", productInfo.productName);
                formData.append("description", productInfo.description);
                formData.append("price", parseFloat(productInfo.productPrice));
                formData.append("slug", productInfo.productSlug);
                formData.append("category", productInfo.category);
                formData.append("created_at", productInfo.createdAt);
                try {
                    const response = await axios.put(
                        `https://shoptinga.onrender.com/api/product/${productInfo.productId}/`,
                        formData,
                        {
                            headers: {
                                'Content-Type': `multipart/form-data`,
                                'Authorization': `JWT ${access}`,
                                'Accept': 'application/json',
                            },
                        }
                      );
                    // console.clear()
                    console.log(response.data)
                    navigate("/dashboard")
                    userContextUsed.functions.handleNotification("Product updated successfully", "success")
                } catch (error) {
                    console.error(error.response.data);
                    props.handleLoader(false)
                    userContextUsed.functions.handleNotification("Failed to update product", "error")
                }
            } else{
                userContextUsed.functions.handleNotification("Failed to verify user", "error")
            }
        } else{
            setNotFound(true)
        }
    }

  return (
    <>
    {notFound===false ? <div className='signup new-product-big'>
            <div className="content">
                <h2 style={{marginBottom: "20px"}}>Edit Product</h2>
                <div className="card">
                    <form onSubmit={handleSubmit}>
                        <div className="info" style={{display: "none"}}>
                            Shoptinga will Recieve a commision of <span>3%</span> for all sales made on the platform.
                        </div>
                        
                        <div className="inpt">
                            <label htmlFor="productName">
                                Title*
                            </label>
                            <input type="text" minLength={4} required id='productName' value={productInfo.productName} onChange={(e)=>{
                                setProductInfo((prev)=>{
                                    return({
                                        ...prev,
                                        productName: e.target.value
                                    })
                                })
                            }} />
                        </div>
                        <div className="inpt">
                            <label htmlFor="productDescription">
                                Description
                            </label>
                            <input type="text" minLength={4} required id='productDescription' value={productInfo.description} onChange={(e)=>{
                                setProductInfo((prev)=>{
                                    return({
                                        ...prev,
                                        description: e.target.value
                                    })
                                })
                            }} />
                        </div>
                        <div className="inpt">
                            <label htmlFor="productPrice">
                                Price ($USD)
                            </label>
                            <input style={{width: "fit-content"}} type="number" required id='productPrice' value={productInfo.productPrice} onChange={(e)=>{
                                setProductInfo((prev)=>{
                                    return({
                                        ...prev,
                                        productPrice: e.target.value
                                    })
                                })
                            }} />
                        </div>
                        <div className="category">
                            <label>Category ~</label>
                            <div className="select">
                                <div className={productInfo.category === "eBooks" ? "active" : ""} onClick={()=>{
                                    toggleCategory("eBooks")
                                }}>EBook</div>
                                <div className={productInfo.category === "Softwares" ? "active" : ""} onClick={()=>{
                                    toggleCategory("Softwares")
                                }}>Software</div>
                                <div className={productInfo.category === "Songs" ? "active" : ""} onClick={()=>{
                                    toggleCategory("Songs")
                                }}>Song</div>
                                <div className={productInfo.category === "Videos" ? "active" : ""} onClick={()=>{
                                    toggleCategory("Videos")
                                }}>Video</div>
                                <div className={productInfo.category === "Courses" ? "active" : ""} onClick={()=>{
                                    toggleCategory("Courses")
                                }}>Course</div>
                            </div>
                        </div>
                        <button>
                            Save changes <HiSparkles style={{marginLeft: "10px"}}/>
                        </button>
                    </form>
                </div>
            </div>
        </div> : <OopsX />}
    </>
  )
}

export default EditProduct